import React from "react";
// import { makeStyles } from "@material-ui/core/styles";

import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

// const useStyles = makeStyles(theme => ({}));

const OptionalFieldMenuItem = props => {
  const { optionalField, handleClick } = props;
  //   const classes = useStyles();

  return (
    <ListItem button onClick={() => handleClick(optionalField)}>
      <ListItemText>{optionalField.label}</ListItemText>
    </ListItem>
  );
};

export default OptionalFieldMenuItem;
